import imageCompression from "browser-image-compression";
import WATERMARK_PNG from "../../../../../img/watermark.png";

const WATERMARK_OPACITY_LIGHT = 0.35; // camada branca
const WATERMARK_OPACITY_DARK = 0.20; // camada preta
const WATERMARK_SIZE_RATIO = 0.38; // maior pois ficará centralizada

function createColoredWatermark(source: HTMLImageElement, width: number, height: number, color: string): HTMLCanvasElement {
    const off = document.createElement("canvas");

    off.width = width;
    off.height = height;
    const octx = off.getContext("2d")!;

    octx.fillStyle = color;
    octx.fillRect(0, 0, width, height);

    octx.globalCompositeOperation = "destination-in";
    octx.drawImage(source, 0, 0, width, height);

    return off;
}

export async function addWatermark(source: Blob | File): Promise<Blob> {
    return new Promise((resolve, reject) => {
        const sourceUrl = URL.createObjectURL(source);
        const img = new Image();

        img.onload = () => {
            URL.revokeObjectURL(sourceUrl);
            
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;

            const ctx = canvas.getContext("2d")!;
            ctx.drawImage(img, 0, 0);

            const wm = new Image();
            wm.onload = () => {
                const wmWidth = canvas.width * WATERMARK_SIZE_RATIO;
                const scale = wmWidth / wm.naturalWidth;
                const wmHeight = wm.naturalHeight * scale;

                const x = (canvas.width - wmWidth) / 2;
                const y = (canvas.height - wmHeight) / 2;

                const whiteWm = createColoredWatermark(wm, wmWidth, wmHeight, "white");
                const blackWm = createColoredWatermark(wm, wmWidth, wmHeight, "black");

                ctx.globalAlpha = WATERMARK_OPACITY_LIGHT;
                ctx.drawImage(whiteWm, x, y);

                ctx.globalAlpha = WATERMARK_OPACITY_DARK;
                ctx.drawImage(blackWm, x, y);

                ctx.globalAlpha = 1;

                canvas.toBlob(
                    (blob) => (blob ? resolve(blob) : reject(new Error("toBlob failed"))),
                    "image/jpeg",
                    0.92
                );
            };
            wm.onerror = () => reject(new Error("Falha ao carregar watermark"));
            wm.src = WATERMARK_PNG;
        };
        img.onerror = () => {
            URL.revokeObjectURL(sourceUrl);
            reject(new Error("Falha ao carregar imagem fonte"));
        };
        img.src = sourceUrl;
    });
}

export async function compressImage(image: File) {

    const compressOptions = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 500,
        useWebWorker: true
    };

    const compressedImage = await imageCompression(image, compressOptions);
    return compressedImage;
}